import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import {
  Alert,
  Box,
  Button,
  FormGroupRow,
  HorizontalFormControl,
} from '../../../../common/components';
import { actions } from '../../redux/sourceActions';
import { Col, Row, Form } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
import { compose } from 'redux';
import Loader from '../../../../common/components/Loader/Loader';
import { push } from 'react-router-redux';
import SelectField from '../../../../common/components/ReduxFormField/SelectField';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import SelectMenu from '../../../../common/components/SelectMenu/SelectMenu';
import { required } from 'redux-form-validators';

const SourceForm = ({
  resource,
  updateSource,
  createSource,
  goTo,
  formValues,
  handleSubmit,
  submitting,
  isEdit,
}) => {
  const handleSubmitSource = (values) => {
    if (values.data.id) {
      return Promise.resolve(
        updateSource(resource.data.id, values, ['broker', 'channel']),
      ).then((resp) => {
        goTo(`/admin/sources/${resp.data.id}`);
      });
    }
    return Promise.resolve(createSource(values)).then((response) => {
      goTo(`/admin/sources/${response.id}`);
    });
  };

  if (!formValues) {
    return <Loader />;
  }
  return (
    <Box>
      <Row>
        <Col sm={12}>
          <h2 className="resource-name">
            {formValues?.attributes?.name ?? 'New Source'}
          </h2>
        </Col>
      </Row>
      <Form horizontal onSubmit={handleSubmit(handleSubmitSource)}>
        <Row>
          <Col xs={6}>
            <Alert />
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <Field
              name="data.attributes.name"
              label="Name"
              labelSize={2}
              component={HorizontalFormControl}
              validate={required({ msg: 'Name is Required' })}
            />
            <Field
              name="data.attributes.status"
              label="Status"
              labelSize={2}
              options={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
              ]}
              component={SelectField}
              validate={required({ msg: 'Status is Required' })}
            />
          </Col>
          <Col sm={6}>
            <FormGroupRow label="Source Group" labelSize={2}>
              <Field
                name="data.relationships.source_type.data.id"
                sourceKey={isEdit ? 'edit' : 'new'}
                optionValuePath={'id'}
                labelSize={2}
                filter={isEdit ? undefined : '?filter[source_type]=Direct,Fulfilment'}
                // autoFilters={[{ type: 'source_type', match: 'Direct' }, { type: 'source_type', match: 'Fulfilment' }]}
                source={'source-types'}
                component={SelectMenu}
              />
            </FormGroupRow>
            {!isEdit && (
              <FormGroupRow label="Channel" labelSize={2}>
                <Field
                  name="data.relationships.channel.data.id"
                  optionValuePath={'id'}
                  url={'/channels?'}
                  filters={[
                    { type: 'status', match: 'active' },
                    {
                      type: 'name',
                      match: 'Call Centre',
                    },
                  ]}
                  isClearable
                  disabled={isEdit}
                  component={AsyncSelectMenu}
                />
              </FormGroupRow>
            )}
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['marketing.source_create'],
                  button: (
                    <Button
                      className="pull-right"
                      type="submit"
                      bsStyle="primary"
                      label="Save Source"
                      isLoading={submitting}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const getInitialValues = (resource) => () => {
  if (resource) {
    return resource;
  }
  return {
    data: {
      attributes: {
        name: '',
        status: 'active',
      },
      relationships: {
        source_type: {
          data: {
            id: '',
          },
        },
        broker: {
          data: {
            id: '',
          },
        },
        channel: {
          data: {
            id: '',
          },
        },
      },
    },
  };
};
const FORM_NAME = 'sourceForm';

export default compose(
  connect(
    (state, props) => ({
      initialValues: getInitialValues(props.resource)(state),
      formValues: getFormValues(FORM_NAME)(state),
    }),
    {
      updateSource: actions.updateSource,
      createSource: actions.createSource,
      goTo: push,
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(SourceForm);
